import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { PERSONNEL_OTHER, PersonnelFacade } from '@portal/application/data-access';
import { isObservable, map } from 'rxjs';
import { mapPersonnelsEntityToFormlySelectOption } from '../util';
import { PortalFieldConfig } from '@portal/form/data-access';

@Injectable()
export class PersonnelPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly personnelFacade = inject(PersonnelFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'Authorized Personnel',
        placeholder: 'Please Select',
        options: this.personnelFacade.allPersonnel$.pipe(map(o => mapPersonnelsEntityToFormlySelectOption(o))),
      },
      expressions: {
        'props.options': ({ props }: PortalFieldConfig) => {
          // TODO: fixing click twice to choose the option
          if (props?.excludeOtherOption) {
            if (Array.isArray(props?.options)) {
              return props.options.filter(o => o.value !== PERSONNEL_OTHER);
            }
            if (isObservable(props.options)) {
              return props.options.pipe(map(o => o.filter(p => p.value !== PERSONNEL_OTHER)));
            }
          }

          return props?.options;
        },
      },
    };
  }
}

export function registerPersonnelPreset(): ConfigOption {
  return { presets: [{ name: 'personnel', config: new PersonnelPresetProvider() }] };
}
